import { render } from "./GroupIcon16.vue.js?vue&type=template&id=4d369ab3!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./GroupIcon16.vue?vue&type=template&id=4d369ab3"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__